<template>
    <div class="law-header">
        <veui-dialog
            title="尊敬的律临会员，您好！"
            :closable="true"
            :open="isShowPositionModal"
            overlay-class="law-header-bjh-dialog law-header-dialog"
            @cancel="closeDialog"
        >
            <p class="edit-dialog-content-sub">
                十月中旬律临小程序将进行整体升级，视觉效果和曝光点位将大幅增加。为提升您的信息展示效果，您需提供【律师职务】信息，以获得更好的展示效果及更多展示位。
            </p>
            <template #foot>
                <veui-button ui="l primary" @click="goToMaterial">
                    去填写
                </veui-button>
            </template>
        </veui-dialog>
    </div>
</template>

<script>
import {mapState} from 'vuex';
import {Dialog, Button} from 'veui';

export default {
    components: {
        'veui-dialog': Dialog,
        'veui-button': Button
    },
    data() {
        return {
            isShowPositionModal: true
        };
    },
    computed: {
        ...mapState({
            userInfoNew: state => state?.lawStore?.userInfoNew
        })
    },
    methods: {
        goToMaterial() {
            this.isShowPositionModal = false;
            // 律所
            if (this.userInfoNew.user_role === 2) {
                this.$route.name !== 'firmintro' && this.$router.push({
                    name: 'firmintro',
                    query: {
                        viewMsg: true
                    }
                });
                return;
            }
            if (this.$route.name !== 'material') {
                this.$router.push({
                    name: 'material',
                    query: {
                        viewMsg: true
                    }
                });
            }
        },
        closeDialog() {
            this.isShowPositionModal = false;
            this.$emit('close');
        }
    }
};
</script>

<style scoped lang="less">
@import "../assets/css/base.less";

.law-header,
.law-header-dialog {
    /deep/.veui-dialog-content {
        width: 440px;

        .veui-dialog-content-head {
            padding-top: 50px;
        }

        .veui-dialog-content-foot {
            padding-top: 24px;
        }

        .veui-button {
            width: 104px;
        }

        .veui-dialog-content-head-close {
            color: #000;
        }
    }
}

</style>